import styled from 'styled-components';
import ContactCard from '~/components/ContactCard';
import { CustomHead } from '~/components/Head';
import StaticPageLayout from '~/components/layouts/StaticPageLayout';
import { contactPoints } from '~/data/contact-us-cards';
import * as LSTVGlobals from '~/globals';

const CardsGrid = styled.div`
  display: grid;
  width: 100%;
  justify-content: center;
  justify-items: center;
  grid-template-columns: repeat(auto-fill, 294px);

  @media ${LSTVGlobals.UserDevice.isMobile} {
    margin-top: 14px;
  }
`;

const ContactPage = () => {
  return (
    <>
      <CustomHead title="Contact Us - Love Stories TV" />
      <StaticPageLayout headerText="We're Here to Help" wideContent>
        <CardsGrid>
          {contactPoints.map((contactPoint, index) => (
            <ContactCard key={index} contactPoint={contactPoint} />
          ))}
        </CardsGrid>
      </StaticPageLayout>
    </>
  );
};

export default ContactPage;
